import request from '@/utils/request'

// login_in 获取Oauth2登录授权链接
export function getLogin() {
  return request({
    url: '/user/oauth2Url',
    method: 'get'
  })
}
// Oauth2登录
export function loginIn(data) {
  return request({
    url: '/user/oauth2Login',
    method: 'post',
	data:new URLSearchParams(data).toString()
  })
}


// 邮箱登录
export function login(data) {
  return request({
    url: '/user/login',
    method: 'post',
	data: data
  })
}
// sems登录
export function semsLogin(data) {
  return request({
    url: '/user/semsLogin',
    method: 'post',
	data: data
  })
}
// 未登录情况下修改密码
export function retrievePassword(data) {
  return request({
    url: '/user/retrievePassword',
    method: 'post',
	data: data
  })
}

